import { render, staticRenderFns } from "./BranchOverlay.vue?vue&type=template&id=42c1f3f6&"
import script from "./BranchOverlay.vue?vue&type=script&lang=js&"
export * from "./BranchOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports